const mixpanelToken = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;
const hygraphToken = process.env.NEXT_PUBLIC_HYGRAPH_AUTH_TOKEN;

export const TOKENS = {
  mixpanel: mixpanelToken,
  hygraph: hygraphToken,
};
